import { TDataSource } from "./dataSource";
import { TEnumerationType } from "./type";

export type TSegment = 'fullGame' | 'dlcAllOther' | 'dlcExpansion' | 'dlcSeasonPass' | 'dlcBattlePass' | 'mtx' | 'subscription' | 'inGameCurrency';

export interface ISegmentProp {
  // 自身的key
  key: string;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: string;
  // 展示在什么平台
  platform?: string;
  // 属于哪个数据源 
  source?: TDataSource;
  enumType: TEnumerationType;
};

export type ISegment = Record<TSegment, ISegmentProp>

export const PC_AND_CONSOLE_SEGMENT: ISegment = {
  fullGame: {
    label: 'Base Game',
    labelKey: 'dbi_segment_full_game_key',
    value: 'Full Game',
    platform: 'pc,console,pc&console',
    key: 'fullGame',
    enumType: 'segment',
  },
  dlcAllOther: {
    label: 'DLC: All Other',
    labelKey: 'dbi_segment_DLC_all_other_key',
    value: 'DLC: All Other',
    platform: 'pc,console,pc&console',
    key: 'fullGame',
    enumType: 'segment',
  },
  dlcExpansion: {
    label: 'DLC: Expansion',
    labelKey: 'dbi_segment_DLC_expansion_key',
    value: 'DLC: Expansion',
    platform: 'pc,console,pc&console',
    key: 'dlcExpansion',
    enumType: 'segment',
  },
  dlcSeasonPass: {
    label: 'DLC: Season Pass',
    labelKey: 'dbi_segment_DLC_content_pre_purchase_pass_key',
    value: 'DLC: Content Pre-Purchase Pass',
    platform: 'pc,console,pc&console',
    key: 'dlcSeasonPass',
    enumType: 'segment',
  },
  dlcBattlePass: {
    label: 'DLC: Battle Pass',
    labelKey: 'dbi_segment_DLC_unlockable_content_pass_key',
    value: 'DLC: Unlockable Content Pass',
    platform: 'pc,console,pc&console',
    key: 'dlcBattlePass',
    enumType: 'segment',
  },
  mtx: {
    label: 'MTX',
    labelKey: 'dbi_segment_MTX_key',
    value: 'MTX',
    platform: 'pc,console,pc&console',
    key: 'mtx',
    enumType: 'segment',
  },
  subscription: {
    label: 'Subscription',
    labelKey: 'dbi_segment_subscription_key',
    value: 'Subscription',
    platform: 'pc,console,pc&console',
    key: 'subscription',
    enumType: 'segment',
  },
  inGameCurrency: {
    label: 'In-Game Currency',
    labelKey: 'dbi_segment_in_game_currency_key',
    value: 'In-Game Currency',
    platform: 'pc,console,pc&console',
    key: 'inGameCurrency',
    enumType: 'segment',
  }
};